import React, { useCallback } from 'react';
import { Redirect, useParams } from 'react-router';
import { CircularProgress } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import Styled from '../StyledComponents';
import { useQueryHelper } from '../../../../libs/hooks';
import Template from './template';
import * as INSTAGRAM_TAGGED_POST_DETAILS from './InstagramInteractionTaggedPostDetails.graphql';
import {
  InstagramInteractionTaggedPostDetails,
  InstagramInteractionTaggedPostDetailsVariables
} from './__generated__/InstagramInteractionTaggedPostDetails';

interface AnayticsStoryPostDetailProps {
  closeModal: () => void;
}

const AnayticsTaggedPostDetail = (props: AnayticsStoryPostDetailProps) => {
  const { closeModal } = props;
  const { t, history, enqueueSnackbar } = useQueryHelper();
  const {
    location: { search, pathname }
  } = history;
  const { id } = useParams<{ id: string }>();
  const postId = Number(new URLSearchParams(search).get('popup'));

  const { data, loading, error } = useQuery<
    InstagramInteractionTaggedPostDetails,
    InstagramInteractionTaggedPostDetailsVariables
  >(INSTAGRAM_TAGGED_POST_DETAILS, {
    variables: { postId, accountId: Number(id) },
    onError: useCallback(() => {
      history.push(pathname);
      closeModal();
      enqueueSnackbar(t('Post was not found'), { variant: 'error' });
    }, [])
  });

  if (loading) {
    return <CircularProgress size={64} thickness={2.4} color="inherit" />;
  }

  if (error) {
    return <Redirect to="/404" />;
  }

  return (
    <Styled.PostDetailWrapper>
      <Template closeModal={closeModal} postData={data?.instagramInteractionTaggedPostDetails} />
    </Styled.PostDetailWrapper>
  );
};

export default AnayticsTaggedPostDetail;
